import React from 'react';
import {TopBar, SideBar, LocationBar } from '../components.js';
import LocationUtil from '../../utils/locationutil.js';


const locations = LocationUtil.locations;

class MainView extends React.Component {

	constructor(props) {
		super(props);
		window.app.page_finished = false;
		this.contentChange = this.contentChange.bind(this);

	}

	componentDidMount() {
		window.app.page_finished = true;
	}

	contentChange(e) {
		e.preventDefault();


	}

	render() {
		window.app.page_finished = false;
		if(window._fiUser.token.length === 0 || window._fiSponsor.sponsors[0].id.length === 0) {
			window._fiUser.loadSessionInfo();
			window._fiSponsor.loadSessionInfo();
		}

		var sideBarLoc = (Array.isArray(this.props.location)) ? this.props.location[this.props.location.length - 1] : this.props.location

		return (
			<div>
		      	<TopBar />
		     	<SideBar locations={locations} location={sideBarLoc} />
		      	<div className="App-MainTable">
		          	<LocationBar location={this.props.location} amount={window._fiSponsor.sponsors[0].total_saved} />
		          	{this.props.content}
		       	</div>
		    </div>
		    );
		}


}



export default MainView;